<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.781 6.96936C8.85084 7.03903 8.90626 7.1218 8.94407 7.21291C8.98188 7.30403 9.00134 7.40171 9.00134 7.50036C9.00134 7.59901 8.98188 7.6967 8.94407 7.78781C8.90626 7.87893 8.85084 7.9617 8.781 8.03136L4.8105 12.0004L8.781 15.9694C8.85073 16.0391 8.90604 16.1219 8.94378 16.213C8.98152 16.3041 9.00095 16.4017 9.00095 16.5004C9.00095 16.599 8.98152 16.6966 8.94378 16.7877C8.90604 16.8788 8.85073 16.9616 8.781 17.0314C8.71127 17.1011 8.62848 17.1564 8.53737 17.1941C8.44626 17.2319 8.34861 17.2513 8.25 17.2513C8.15138 17.2513 8.05373 17.2319 7.96262 17.1941C7.87151 17.1564 7.78873 17.1011 7.719 17.0314L3.219 12.5314C3.14915 12.4617 3.09374 12.3789 3.05593 12.2878C3.01812 12.1967 2.99866 12.099 2.99866 12.0004C2.99866 11.9017 3.01812 11.804 3.05593 11.7129C3.09374 11.6218 3.14915 11.539 3.219 11.4694L7.719 6.96936C7.78867 6.89952 7.87143 6.8441 7.96255 6.80629C8.05367 6.76849 8.15135 6.74902 8.25 6.74902C8.34865 6.74902 8.44633 6.76849 8.53745 6.80629C8.62857 6.8441 8.71133 6.89952 8.781 6.96936Z"
      fill="#343A40"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.75 12C3.75 11.8011 3.82902 11.6103 3.96967 11.4697C4.11032 11.329 4.30109 11.25 4.5 11.25H20.25C20.4489 11.25 20.6397 11.329 20.7803 11.4697C20.921 11.6103 21 11.8011 21 12C21 12.1989 20.921 12.3897 20.7803 12.5303C20.6397 12.671 20.4489 12.75 20.25 12.75H4.5C4.30109 12.75 4.11032 12.671 3.96967 12.5303C3.82902 12.3897 3.75 12.1989 3.75 12Z"
      fill="#343A40"
    />
  </svg>
</template>
<script>
export default {
  name: 'ArrowLeftIcon',
}
</script>
